var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "renderer" },
    [
      _c(
        _vm.linkTag,
        { tag: "router-link", class: _vm.classNames, attrs: { to: _vm.link } },
        [_vm._v("\n    " + _vm._s(_vm.object.name) + "\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }